import { isBrowser } from "../browser"
import type { LocalizedRouteMap } from "./localized-routes"

/**
 * Returns the localized route map from the environment variable.
 * This function needs to be defined in a separate file to the one that sets the environment variable, otherwise Webpack's flow will not be able to resolve the environment variable correctly.
 * @returns The localized route map.
 */
export const getLocalizedRouteMap = (): LocalizedRouteMap => {
  try {
    return JSON.parse(process.env.GATSBY_LOCALIZED_ROUTE_MAP ?? "")
  } catch (error) {
    // If the error for some reason happens in the browser, we return an empty object to avoid breaking the app.
    if (isBrowser()) {
      return {} as LocalizedRouteMap
    }
    throw new Error("Error parsing localized route map", { cause: error })
  }
}
